<template>
  <div class="home">
    <Header></Header>

    <!-- 轮播图部分 -->
    <div class="rotationmap" >
      <el-carousel :interval="5000" arrow="always" :height="bannerHeight + 'px'">
        <el-carousel-item v-for="(item,index) in rotationmap" :key="index">
          <img :src="item.url" ref="bannerHeight" @load="imgLoad" class="bannerImg" />
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 企业优势 -->
    <div class="advantage">
      <div class="advantage-title">
        <p>企业优势</p>
        <p>COEPOEATE ADVANTAGE</p>
      </div>

      <div class="content">
        <ul>
          <li>
            <img src="../assets/home_icon_ssx.png" />
            <p class="title">实时性</p>
            <i></i>
            <p class="word">免除人工抄写流程无需 </p>
            <p class="word"> 电话询问生产进度</p>
            <p class="word">故障维修及时调度通知</p>
          </li>

          <li>
            <img src="../assets/home_icon_zqx.png" />
            <p class="title">正确性</p>
            <i></i>
            <p class="word">生产进度精准了解</p>
            <p class="word">机台自动报工</p>
            <p class="word">避免人工抄写错误</p>
          </li>

          <li>
            <img src="../assets/home_icon_fbx.png" />
            <p class="title">方便性</p>
            <i></i>
            <p class="word">工厂订制化APP</p>
            <p class="word">与企业私有服务器</p>
            <p class="word">连网即可使用</p>
          </li>

          <li>
            <img src="../assets/home_icon_kczx.png" />
            <p class="title">可操作性</p>
            <i></i>
            <p class="word">简单流程轻松操作</p>
            <p class="word">各项功能一按即查</p>
            <p class="word">管理者一目了然</p>
          </li>
        </ul>
      </div>

      <div class="content-sj">
        <ul>
          <li>
            <img src="../assets/home_icon_ssx.png" />
            <p class="title">实时性</p>
            <i></i>
            <p class="word">无需人工抄写</p>
            <p class="word">无需电话询问</p>
            <p class="word">故障及时通知</p>
          </li>

          <li>
            <img src="../assets/home_icon_zqx.png" />
            <p class="title">正确性</p>
            <i></i>
            <p class="word">精准了解进度</p>
            <p class="word">机台自动报工</p>
            <p class="word">避免人工错误</p>
          </li>

          <li>
            <img src="../assets/home_icon_fbx.png" />
            <p class="title">方便性</p>
            <i></i>
            <p class="word">工厂订制APP</p>
            <p class="word">与企业服务器</p>
            <p class="word">连网即可使用</p>
          </li>

          <li>
            <img src="../assets/home_icon_kczx.png" />
            <p class="title">可操作性</p>
            <i></i>
            <p class="word">流程操作简单</p>
            <p class="word">功能一按即查</p>
            <p class="word">管理一目了然</p>
          </li>
        </ul>
      </div>
    </div>

    <!-- 企业简介 -->
    <div class="aboutus">
      <div class="top-out">
        <div class="top">
          <div class="top-left">
            <div class="title">
              <p class="zw">企业简介</p>
              <p class="yw">ABOUT US</p>
            </div>
            <p class="left-word">
              苏州弘瀚自动化科技有限公司于2002年成立，公司位于苏州市高新区，至今已耕耘于电子业自动化十多年，有着丰富的行业经验和很强的非标自动化系统集成能力。服务据点遍布全国各地，重视研发，拥有78项实用新型专利和8项发明专利。自动化仓储与物流系统、产线自动化设计规划、自动化解决方案、智能设备云系统等多元化产品。</p>
            <p class="left-word">公司坚持以崇本务实、发明创新 关怀员工、永续经营为理念，致力于发展为一流的非标自动化设备综合服务企业。</p>      
          </div>
      
          <img class="top-right" src="../assets/home_img_qyjj2.png">
        </div>
      </div>

      <div class="bottom">
        <ul>
          <li>
            <p>20</p>
            <p>2002年至今，</p>
            <p>企业已有20年发展历史</p>
          </li>

          <li>
            <p>100+</p>
            <p>自动化领导者，业务遍布</p>
            <p>全国100+个省市</p>
          </li>

          <li>
            <p>86</p>
            <p>实用新型专利78项，</p>
            <p>发明专利8项</p>
          </li>

          <li>
            <p>7</p>
            <p>公司目前于合肥、苏州、深圳 、</p>
            <p>南京、 宁波、台湾皆有服务据点</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="aboutus-sj">
      <div class="aboutus-title">
        <p>企业简介</p>
        <p></p>
      </div>

      <div class="content">
        <div class="fathbox">
          <img src="../assets/home_img_qyjj2.png">
          <ul>
            <li>
              <p>20</p>
              <p>发展历史</p>
            </li>

            <li>
              <p>100+</p>
              <p>业务范围</p>
            </li>

            <li>
              <p>86</p>
              <p>专利技术</p>
            </li>

            <li>
              <p>7</p>
              <p>服务据点</p>
            </li>
          </ul>
        </div>
        <p class="word">苏州弘瀚自动化科技有限公司于2002年成立，公司位于苏州市高新区，至今已耕耘于电子业自动化十多年，有着丰富的行业经验和很强的非标自动化系统集成能力。服务据点遍布全国各地，重视研发，拥有78项实用新型专利和8项发明专利。自动化仓储与物流系统、产线自动化设计规划、自动化解决方案、智能设备云系统等多元化产品。</p>
        <p class="word">公司坚持以崇本务实、发明创新 关怀员工、永续经营为理念，致力于发展为一流的非标自动化设备综合服务企业。</p>   
      </div>
    </div>

    <!-- 产品中心 -->
    <div class="product">
      <div class="title">
        <div class="left">
          <p>产品中心</p>
          <p>COEPOEATE ADVANTAGE</p>
        </div>

        <div class="right">
          <el-row>
            <router-link to="Product">
              <el-button plain>查看更多</el-button>
            </router-link>
          </el-row>
        </div>
      </div>

      <div class="content">
        <ul>
          <li v-for="(item,index) in ProductList" :key="index">
            <router-link :to="{path: '/ProductDetails', query: {productid: item.productid}}" tag="div">
              <img :src="require('@/assets/product/' + item.imgprqurl)" />
              <p>{{item.title}}</p>
            </router-link>
          </li>
        </ul>
      </div>
    
      <div class="minde">
        <div class="top">
          <img src="../assets/home_img_kjrk.png" alt="" >
          <img src="../assets/home_img_kjrk_sj.png" alt="" >
          <div class="minde-content-wrap">        
            <ul>
              <li>
                <router-link :to="{path: '/about', query: {tabid: 2}}" tag="div">
                  <img src="../assets/home_icon_fzlc.png">
                  <p>发展历程</p>
                </router-link>
              </li>

              <li>
                <router-link :to="{path: '/about', query: {tabid: 1}}" tag="div">
                  <img src="../assets/home_icon_ryzz.png">
                  <p>荣誉资质</p>
                </router-link>
              </li>

              <li>
                <router-link :to="{path: '/about', query: {tabid: 0}}" tag="div">
                  <img src="../assets/home_icon_hzhb.png">
                  <p>合作伙伴</p>
                </router-link>
              </li>
            </ul>
          </div>
        </div>

        <div class="bottom">
          <div class="left"> 
            <img src="../assets/home_img_sgsx.png" alt="">
          </div>
          
          <div class="bottomnr">
            <div class="bottomwz">
              <div class="title">
                <p>工业4.0，三个设想</p>
                <p>THREE SCENARIOS</p>
              </div>

              <ul>
                <li>
                  <p>产品</p>
                  <p>集成有动态数字存储器、感知和通信能力，</p>
                  <p>承载着在其整个供应链和生命 周期中所需</p>
                  <p>的各种必要信息。</p>
                </li>

                <li>
                  <p>设施</p>
                  <p>由整个生产价值链所集成，</p>
                  <p>可实现自组织。</p>
                </li>

                <li>
                  <p>管理</p>
                  <p>能够根据当前的状况灵活决定生产过程。</p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="bottom-sj">
          <div class="title-sj">
            <p>工业4.0，三个设想</p>
            <p></p>
          </div>

          <div class="top-wrap">       
            <div class="top-sj">
              <div class="word">
                <p>产品</p>
                <p>集成有动态数字存储器、感知和通信能力，承载着在其整个供应链和生命 周期中所需的各种必要信息。</p>
              </div>
              <div class="word">
                <p>设施</p>
                <p>由整个生产价值链所集成，可实现自组织。</p>
              </div>
              <div class="word">
                <p>管理</p>
                <p>能够根据当前的状况灵活决定生产过程。</p>
              </div>
            </div>
            <img src="../assets/home_img_sgsx_sj.png" />
          </div>
        </div>
      </div>
    </div>
    
    <!-- 企业实力 -->
    <div class="strength">
      <div class="title">
        <p><span>七大</span>据点，见证弘瀚<span>企业实力</span></p>
        <p>公司目前于合肥、苏州、深圳 、南京、 宁波、台湾皆有服务据点</p>
      </div>

      <div class="content-out">
        <img src="../assets/home_img_judian.png" />
        <img src="../assets/home_img_judian_sj.png" />

        <div class="content">
          <div class="right">
            <el-row>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  <img src="../assets/home_icon_point.png" />
                  <p>服务据点遍布， 年营业额 约 2000W USD</p>
                </div>
              </el-col>

              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  <img src="../assets/home_icon_point.png" />
                  <p>耕耘电子业自动化二十年，经验丰富</p>
                </div>
              </el-col>

              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  <img src="../assets/home_icon_point.png" />
                  <p>重视研发，拥有多项专利技术</p>
                </div>
              </el-col>

              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  <img src="../assets/home_icon_point.png" />
                  <p>非标自动化系统，集成能力强</p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>

    <!-- 行业资讯 -->
    <div class="news">
      <div class="title">
        <p>行业资讯</p>
        <p>INDUSTRY INFORMATION</p>
      </div>

      <div class="top">
        <el-row>
          <el-col :span="24" v-for="(item,index) in newList.slice(0,1)" :key="index">
            <div class="left">
              <router-link :to="{path: '/newsDetails', query: {newid: item.newid}}" tag="div">
                <img :src="require('@/assets/news/' + item.topimg)" />
              </router-link>
            </div>

            <div class="right">
              <router-link :to="{path: '/newsDetails', query: {newid: item.newid}}" tag="div">
                <p>{{item.title}}</p>
                <p>{{item.date.substring(0,10)}}</p>
                <p>{{item.substance}}</p>
              </router-link>
              <el-row>
                <router-link :to="{path: 'News'}">
                  <el-button plain>查看更多</el-button>
                </router-link>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="bottom">
        <ul>
          <li v-for="(item,index) in newList.slice(1,4)" :key="index">
            <router-link :to="{path: '/newsDetails', query: {newid: item.newid}}" tag="div">
              <div class="content">
                <div class="left">
                  <p>{{item.date.substring(8,10)}}</p>
                  <p>{{item.date.substring(0,7)}}</p>
                </div>

                <div class="right">
                  <p>{{item.title}}</p>
                  <p>{{item.substance}}</p>  
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="news-sj">
        <div class="top-sj" v-for="(item,index) in newList.slice(0,1)" :key="index">
          <router-link :to="{path: '/newsDetails', query: {newid: item.newid}}" tag="div">
            <img :src="require('@/assets/news/' + item.topimg)" />
            <div class="word">
              <p>{{item.date.substring(0,10)}}</p>
              <p>{{item.title}}</p>
            </div>
          </router-link>
        </div>

        <div class="bottom-sj">
          <ul>
            <li v-for="(item,index) in newList.slice(1,4)" :key="index">
              <router-link :to="{path: '/newsDetails', query: {newid: item.newid}}" tag="div">
                <div class="left">
                  <p>{{item.date.substring(0,4)}}</p>
                  <p>{{item.date.substring(5,10)}}</p>
                </div>
                <div class="right">
                  <p>{{item.title}}</p>
                  <p>{{item.substance}}</p>
                </div>
              </router-link>
            </li>
          </ul>
          <div class="button">
            <router-link :to="{path: 'News'}">
              <p>查看更多</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="return-top">
      <el-backtop :bottom="60">
        <div
          style="{
            height: 80px;
            width: 80px;
            background-color: #A8A8A8;
            text-align: center;
            line-height: 40px;
          }"
        >
          <i style="color:#fff" class="el-icon-arrow-up"></i>
        </div>        
      </el-backtop>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
// 调用公共组件
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import newlist from '../../static/newlist.js' // 引入
export default {
  name: 'Home',
  components: {
    Header,
    Footer,
  },
  created () {
    const that = this;
    that.newList = newlist.newList[0];
    that.ProductList = newlist.ProductList[0];
    that.newList.sort((a,b)=>b.newid-a.newid);//降序。 升序则a在前面
    that.ProductList.sort((a,b)=>b.productid-a.productid);//降序。 升序则a在前面
    that.Producarr();
  },
  data(){
    return {
      rotationmap: [{
          url:require("../assets/banner_img1.png")
        },
        {
          url:require("../assets/banner_img2.png")
        },
        {
          url:require("../assets/banner_img3.png")
        }
      ],
      bannerHeight: '',
      newList: [],
      ProductList: [],
      backTop: false,
      screenWidth: '',
    };
  },
  watch: {
    screenWidth(val){
      const that = this;
      that.screenW(val);
    }
  },
  mounted () {
    const that = this;
    // 下面是增加监听事件，当视口发生变化的时候，得到此时图片的高度赋值给 bannerHeight
    that.imgLoad()
    window.addEventListener('resize', () => {
      if (typeof(that.$refs.bannerHeight[0]) != "undefined"){
        that.bannerHeight = that.$refs.bannerHeight[0].height
        that.imgLoad()
      }
    }, false)

    that.screenWidth = document.body.clientWidth;

    // 监听屏幕变化
    window.addEventListener("resize", function() {
      return (() => {
        window.screenWidth= document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    });
  },
  methods: {
    Producarr(){
      const that = this;
      let screenWidth = document.body.clientWidth;
      if(screenWidth < 801){
        var newProducarr = [];
        for(var i=0;i<9;i++){
          newProducarr.push(that.ProductList[i])
        }
        newProducarr.push(that.ProductList[0]);
        newProducarr.push(that.ProductList[1]);
        that.ProductList = newProducarr;
      }else{
        var newProducarr = [];
        for(var i=0;i<9;i++){
          newProducarr.push(that.ProductList[i])
        }
        newProducarr.push(that.ProductList[0]);
        newProducarr.push(that.ProductList[1]);
        newProducarr.push(that.ProductList[2]);
        that.ProductList = newProducarr;
      }
    },

    // 下面的 imgLoad 是页面渲染完成的加载方法，确保屏幕中的图片的高度第一次渲染到页面。
    imgLoad () {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height;
      })
    },

    // 屏幕图片变化
    screenW (val) {
      const that = this;
      if(val < 801){
        that.rotationmap = [];
        var newobj = [
              {url:require("../assets/banner_img1_sj.png")},
              {url:require("../assets/banner_img2_sj.png")},
              {url:require("../assets/banner_img3_sj.png")}
            ];

        that.rotationmap = newobj;
      }else{
        that.rotationmap = [];
        var newobj = [
              {url:require("../assets/banner_img1.png")},
              {url:require("../assets/banner_img2.png")},
              {url:require("../assets/banner_img3.png")}
            ];
        that.rotationmap = newobj;
      }
    },
  },
}
</script>

<style scoped>
  .rotationmap >>> .el-carousel__item img{
    width: 100%;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
     background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
     background-color: #d3dce6;
  }

  /* 企业优势 */

 .advantage{
    padding: 100px 0 0 0;
    width: 66.66%;
    margin: 0 auto;
  }

  .advantage-title p:nth-child(1){
    font-size: 48px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #323F4F;
  }

  .advantage-title p:nth-child(2){
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #DFDFDF;
  }

  .advantage .content{
    display: block;
  }

  .advantage .content-sj{
    display: none;
  }

  .advantage .content ul{
    padding-top: 70px;
    display: flex;
    list-style: none;
  }

  .advantage .content ul li{
    box-sizing: border-box;
    width: 25%;
    min-width: 130px;
    height: 480px;
    text-align: center;
  }

  .advantage .content ul li img{
    display: block;
    margin: 80px auto 40px;
    width: 50%;
  }

  .advantage .content ul li .title{
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 36px;
    color: #323F4F;
  }

  .advantage .content ul li i{
    display: block;
    width: 40px;
    height: 0px;
    margin: 20px auto;
    border: 1px solid #FFC200;
  }

  .advantage .content ul li .word{
    margin: 0 auto;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #666666;
  }

  @media (max-width: 1000px){ 
    .advantage .content ul li .word{
      font-size: 12px;
    }
  }

  /* 企业简介 */

  .aboutus{
    margin-top: 130px;
    display: block;
  }

  .aboutus-sj{
    display: none;
  }

  .aboutus .top-out{
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .aboutus .top{
    width: 83.333%;
    height: 720px;
    display: flex;
  }

  .aboutus .top .top-left{
    width: 40%;
    padding-top: 43px;
  }

  .aboutus .top .top-left .title{
    position: relative;
    widows: 300px;
    height: 330px;
  }

  .aboutus .top .top-left .zw{
    position: absolute;
    top: 0;
    left: 70px;
    width: 24px;
    height: 121px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #FFC200;
  }

  .aboutus .top .top-left .yw{
    position: absolute;
    top: 0;
    left: 64px;
    transform:rotate(90deg);
    transform-origin: left top;
    width: 253px;
    height: 64px;
    font-size: 48px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #323F4F;
  }

  .aboutus .left-word{
    padding-right: 35px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 34px;
    color: #666666;
    text-align: justify;
  }

  .aboutus .top-right{
    width: 60%;
  }

  .aboutus .bottom{
    width: 66.66%;
    height: 200px;
    margin: 0 auto;
    padding-top: 95px;
  }

  .aboutus .bottom ul{
    display: flex;
    justify-content: space-between;
    width: 100%;
    list-style: none;
  }

  .aboutus .bottom ul li{
    width: 25%;
    height: 120px;
  }

  .aboutus .bottom ul li p:nth-child(1){
    font-size: 48px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFC200;
  }

  .aboutus .bottom ul li p:nth-child(2){
    padding-right: 15px;
    font-size: 15px;
    font-family: MicrosoftYaHei;
    line-height: 28px;
    color: #666666;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }

  .aboutus .bottom ul li p:nth-child(3){
    padding-right: 15px;
    font-size: 15px;
    font-family: MicrosoftYaHei;
    line-height: 28px;
    color: #666666;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }

  @media (max-width: 1400px){ 
    .aboutus .bottom ul li p:nth-child(2){
      font-size: 13px;
    }

    .aboutus .bottom ul li p:nth-child(3){
      font-size: 13px;
    }
  }

  @media (max-width: 1250px){
    .aboutus .top .top-left .title{
      height: 300px;
    }

    .aboutus .left-word{
      font-size: 14px;
    } 

    .aboutus .bottom ul li p:nth-child(2){
      font-size: 12px;
      line-height: 20px;
    }

    .aboutus .bottom ul li p:nth-child(3){
      font-size: 12px;
      line-height: 20px;
    }
  }

  @media (max-width: 1000px){ 
     .aboutus .left-word{
      font-size: 12px;
    } 
  }

  /* 产品中心 */

  .product{
    padding-top: 100px;
  }

  .product .title{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 66.66%;
    margin: 0 auto;
  }

  .product .title p:nth-child(1){
    font-size: 48px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #323F4F;
  }

  .product .title p:nth-child(2){
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #DFDFDF;
  }
  
  .product .content{
    overflow: hidden;
    margin: 60px auto 140px;
    width: 66.66%;
    height: 350px;
    white-space:nowrap;
    display: block;
  }

  .product .content ul{
    list-style: none;
    height: 330px;
    animation:myfirst1 50s infinite linear;
    -webkit-animation: myfirst 50s infinite linear; 
    display: inline-block;
  }

  .product .content ul:hover{
    animation-play-state: paused;
    -webkit-animation-play-state: paused; 
  }

  @keyframes myfirst
  {
    0% { transform: translateX(0); }
    100%{ transform: translateX(calc(-100% + 1080px)); }
  }

  @-webkit-keyframes myfirst 
  {
    0% { transform: translateX(0); }
    100%{ transform: translateX(calc(-100% + 1080px)); }
  }
  
  .product .content ul li{
    padding-right: 20px;
    width: 360px;
    height: 330px;
    display:inline-block;
  }

  .product .content ul li:last-child{
    padding-right: 0;
  }

  .product .content ul li img{
    width: 100%;
  }

  .product .content ul li p{
    padding: 15px 0 0 20px;
    text-align: left;
  }

  .product .minde .top{
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
  }

  .product .minde .top > img{
    width: 100%;
  }

  .product .minde .top > img:nth-child(1){
    display: block;
  }
  
  .product .minde .top > img:nth-child(2){
    display: none;
  }

  .minde-content-wrap{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .product .minde .top ul{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 56%;
    height: 100%;
    margin: 0 auto;
    list-style: none;
  }

  .product .minde .top ul li{
    text-align: center;
    width: 24%;
  }

  .product .minde .top ul li a{
    text-decoration:none;
  }

  .product .minde .top ul li img{
    width: 100%;
    margin-bottom: 25px;
  }

  .product .minde .top ul li p{
    font-size: 24px;
    font-family: MicrosoftYaHei;
    line-height: 24px;
    color: #FFFFFF;
  }

  @media (max-width: 1000px){ 
    .product .minde .top ul li img{
      width: 80%;
      margin-bottom: 12px;
    }

    .product .minde .top ul li p{
      font-size: 20px;
      font-family: MicrosoftYaHei;
      line-height: 24px;
      color: #FFFFFF;
    }
  }

  .product .minde .bottom{
    position: relative;
    display: block;
    margin-top: 130px;
    width: 100%;
  }
  
  .product .minde .bottom .left{
    width: 100%;
  }

  .product .minde .bottom .left > img{
    width: 49.5%;
    display: block;
  }

  .product .minde .bottom .bottomnr{
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 100%;
  }

 .product .minde .bottom .bottomnr .bottomwz{
    box-sizing: border-box;
    width: 88%;
    height: 72.58%;
    background-color: #fff;
  }

 .product .minde .bottom .bottomnr .bottomwz .title{
    width: 410px;
    display: flex;
    flex-flow: wrap;
    float: right;
    margin-right: 16.66%;
    padding-top: 130px;
  }

 @media (max-width: 1680px){ 
    .product .minde .bottom .bottomnr .bottomwz .title{
      padding-top: 100px;
    }
  }

 @media (max-width: 1280px){ 
   .product .minde .bottom .bottomnr .bottomwz .title{
     padding-top: 80px;
    }
  }

 .product .minde .bottom .bottomnr .bottomwz > .title p:nth-child(1){
    width: 100%;
    font-size: 48px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #323F4F;
    margin-bottom: 6px;
  }

 .product .minde .bottom .bottomnr .bottomwz > .title p:nth-child(2){
    width: 100%;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #DFDFDF;
  }

  .product .minde .bottom .bottomnr .bottomwz ul{
    display: flex;
    justify-content: space-around;
    clear: both;
    list-style: none;
    padding-top: 90px;
  }

  @media (max-width: 1680px){ 
   .product .minde .bottom .bottomnr .bottomwz ul{
     padding-top: 80px;
   }
 }

  @media (max-width: 1280px){ 
    .product .minde .bottom .bottomnr .bottomwz ul{
      padding-top: 70px;
    }
  }

  .product .minde .bottom .bottomnr .bottomwz ul li{
    background: #fff;
  }

  .product .minde .bottom .bottomnr .bottomwz ul li p{
    padding-right: 15px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #666666;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .product .minde .bottom .bottomnr .bottomwz ul li p:nth-child(1){
    margin-bottom: 15px;
    font-size: 36px;
    font-family: Microsoft YaHei;
    line-height: 44px;
    font-weight: 400;
    color: #323F4F;
  }

  @media (max-width: 1080px){ 
    .product .minde .bottom .bottomnr .bottomwz .title{
      padding-top: 30px;
    }

    .product .minde .bottom .bottomnr .bottomwz > .title p:nth-child(1){
      font-size: 40px;
      margin-bottom: 6px;
    }

    .product .minde .bottom .bottomnr .bottomwz > .title p:nth-child(2){
      font-size: 20px;
    }

    .product .minde .bottom .bottomnr .bottomwz ul{
      padding-top: 30px;
    }

    .product .minde .bottom .bottomnr .bottomwz ul li p{
      font-size: 12px;
      line-height: 26px;
    }

    .product .minde .bottom .bottomnr .bottomwz ul li p:nth-child(1){
      margin-bottom: 5px;
      font-size: 25px;
      line-height: 36px;
    }
  }

  .product .minde .bottom-sj{
    display: none;
  }

  /* 企业实力 */

  .strength{
    padding-top: 160px;
  }

  .strength .title{
    text-align: center;
  }

  .strength .title p:nth-child(1){
    font-size: 48px;
    font-family: Microsoft YaHei;
    font-weight: 400;
  }

  .strength .title p:nth-child(1) span{
    color: #FFC200;
  }

  .strength .title p:nth-child(2){
    margin-top: 10px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }

  .strength .content-out{
    position: relative;
    margin-top: 55px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .strength .content-out > img{
    width: 100%;
  }

  .strength .content-out > img:nth-child(1){
    display: block;
  }

  .strength .content-out > img:nth-child(2){
    display: none;
  }

  .strength  .content{
    position: absolute;
    left:0px;
    right: 0px;
    top:0px;
    bottom: 0px;
    width: 66.66%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    z-index: 20px;
  }

  .strength .content .left{
    width: 50%;
  }

  .strength .content .left img{
    width: 100%;
  }

  .strength .content .right{
    box-sizing: border-box;
    width: 42%;
    display: flex;
    align-items: center;
  }

  .strength .content .right >>> .grid-content{
    display: flex;
    align-items: center;
    padding-left: 30px;
  }

  .strength .content .right >>> img{
    display: block;
    width: 4.16%;
    margin-right: 12px;
  }

  .strength .content .right >>> p{
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 60px;
    overflow: hidden;
    white-space: nowrap;
  }

  @media screen and (max-width: 1680px){
    .strength .content .right >>> p{
      font-size: 18px;
    }
  }

  @media screen and (max-width: 1420px){
    .strength .content .right >>> p{
      font-size: 16px;
    }
  }

  @media screen and (max-width: 1260px){
    .strength .content .right >>> p{
      font-size: 14px;
    }
  }

  /* 行业资讯 */

  .news{
    padding-top: 100px;
    padding-bottom: 40px;
  }

  .news .title{
    text-align: center;
  }

  .news .title p:nth-child(1){
    font-size: 48px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #323F4F;
  }

  .news .title p:nth-child(2){
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #DFDFDF;
  }

  .news .top{
    width: 66.66%;
    margin: 90px auto 0;
  }

  .news .top >>> .el-col{
    display: flex;
  }

  .news .top .left{
    width: 40%;
    overflow: hidden;
    cursor: pointer;
  }

  .news .top .left img{
    width: 100%;
    height: 320px;
    display: block;
  }

  .news .top .right{
    width: 60%;
    padding-left: 45px;
  }

  .news .top .right p:nth-child(1){
    padding-top: 45px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
    color: #222222;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }

  .news .top .right p:nth-child(1):hover{
    color: #FFC200;
  }

  .news .top .right p:nth-child(2){
    display: block;
    margin: 15px 0 30px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    cursor: pointer;
  }

  .news .top .right p:nth-child(3){
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #666666;
    text-align: justify;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    cursor: pointer;
  }

  .news .top .right >>> .el-button{
    margin-top: 20px;
    border-radius: 10px;
  }

  .news .top .right >>> a{
    text-decoration: none;
    color: #222;
  }

  .news .bottom{
    width: 66.66%;
    margin: 0 auto;
  }

  .news .bottom ul{
    list-style: none;
  }

  .news .bottom ul li{
    height: 300px;
    border-bottom: 1px solid #BFBFBF;
    display: flex;
    align-items: center;
  }

  .news .bottom ul li .content{
    width: 100%;
    height: 200px;
    cursor:pointer;
  }

  .news .bottom ul li .content:hover{ 
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  }

  .news .bottom ul li .content .left{
    float: left;
    box-sizing: border-box;
    width: 200px;
    height: 200px;
    margin-right: 55px;
  }

  .news .bottom ul li .content:hover .left{
    background-color: #FFC200;
  }

  .news .bottom ul li .left p:nth-child(1){
    padding-top: 35px;
    text-align: center;
    font-size: 72px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
  }

  .news .bottom ul li .left p:nth-child(2){
    text-align: center;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    color: #999999;
  }

  .news .bottom ul li .content:hover .left p{
    color: #FFFFFF;
  }

  .news .bottom ul li .right p:nth-child(1){
    padding-top: 30px;
    margin: 0 0 24px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }

  .news .bottom ul li .content:hover .right p:nth-child(1){
    color: #FFC200;
  }

  .news .bottom ul li .right p:nth-child(2){
    padding-right: 100px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    text-align: justify;
    color: #999999;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .news-sj{
    display: none;
  }

  @media (max-width: 800px){ 

    /* 企业优势 */

    .advantage{
      padding: 40px 0 0;
      width: 100%;
      margin: 0;
      box-sizing: border-box;
    }

    .advantage-title p:nth-child(1){
      padding: 0 20px;
      font-size: 25px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #323F4F;
    }

    .advantage-title p:nth-child(2){
      margin: 15px 0 0 20px;
      font-size: 0;
      width: 55px;
      height: 2px;
      background-color: #FFC200;
    }

    .advantage .content{
      display: none;
    }

    .advantage .content-sj{
      display: block;
    }

    .advantage .content-sj ul{
      padding-top: 10px;
      display: flex;
      justify-content: space-evenly;
      list-style: none;
    }

    .advantage .content-sj ul li{
      box-sizing: border-box;
      width: 22%;
      text-align: center;
      padding-bottom: 10px;
    }

    .advantage .content-sj ul li img{
      display: block;
      margin: 20px auto 5px;
      width: 65%;
    }

    .advantage .content-sj ul li .title{
      font-size: 16px;
      line-height: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #323F4F;
    }

    .advantage .content-sj ul li i{
      display: block;
      width: 25%;
      height: 0px;
      margin: 5px auto 10px;
      border: 1px solid #FFC200;
    }

    .advantage .content-sj ul li .word{
      width: 100%;
      font-size: 12px;
      line-height: 25px;
      text-align: center;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }

    /* 企业简介 */

    .aboutus{
      display: none;
    }

    .aboutus-sj{
      display: block;
    }
  
    .aboutus-title{
      padding-top: 40px;
    }

    .aboutus-title p:nth-child(1){
      text-align: center;
      font-size: 25px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #323F4F;
    }

    .aboutus-title p:nth-child(2){
      font-size: 0;
      width: 55px;
      height: 2px;
      background-color: #FFC200;
      text-align: center;
      margin: 15px auto 0;
    }

    .aboutus-sj .content{
      width: 100%;
      margin-top: 35px;
    }

    .aboutus-sj .content .fathbox{
      width: 100%;
      box-sizing: border-box;
      position: relative;
      padding-bottom: 69px;
    }

    .aboutus-sj .content .fathbox img{
      width: 100%;
      display: block;
    }

    .aboutus-sj .content .fathbox ul{
      position: absolute;
      left: 20px;
      bottom: 0;
      box-sizing: border-box;
      width: 92%;
      display: flex;
      justify-content: space-around;
      list-style: none;
      background-color: #fff;
      padding: 15px 0 0;
    }

    .aboutus-sj .content .fathbox ul li{
      width: 20%;
    }

    .aboutus-sj .content .fathbox ul li p:nth-child(1){
      padding: 10px 0 5px;
      font-size: 22px;
      font-family: DINPro-Medium, DINPro;
      font-weight: 500;
      color: #FFC200;
      line-height: 30px;
    }

    .aboutus-sj .content .fathbox ul li p:nth-child(2){
      padding-bottom: 10px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 30px;
      font-size: 13px;
    }

    .aboutus-sj .content .word{
      width: 100%;
      padding: 0 25px;
      box-sizing: border-box;
      text-align: justify;
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
      line-height: 25px;
    }

    /* 产品中心 */

    .product{
      width: 100%;
      padding-top: 30px;
    }

    .product >>> .title{
      box-sizing: border-box;
      width: 100%;
      display: flex;
      align-items: flex-start;
    }

    .product >>> .title .left p:nth-child(1){
      padding: 0 20px;
      font-size: 25px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #323F4F;
    }

    .product >>> .title .left p:nth-child(2){
      margin: 15px 0 0 20px;
      font-size: 0;
      width: 55px;
      height: 2px;
      background-color: #FFC200;
    }

    .product >>> .title .right .el-button{
      border: 1px solid transparent;
      font-size: 15px;
      padding: 8px 20px;
    }

    .product .content{
      overflow: hidden;
      box-sizing: border-box;
      width: 92%;
      height: 100%;
      margin: 30px auto 0;
    }

    .product .content ul{
      height: 170px;
      animation:myfirstsj 50s infinite linear;
      -webkit-animation: myfirstsj 50s infinite linear; 
    }

    @keyframes myfirstsj
    {
      0% { transform: translateX(0); }
      100%{ transform: translateX(calc(-100% + 370px)); }
    }

    @-webkit-keyframes myfirstsj 
    {
      0% { transform: translateX(0); }
      100%{ transform: translateX(calc(-100% + 370px)); }
    }

    .product .content ul li{
      width: 170px;
      height: 170px;
    }

    .product .content ul li img{
      display: block;
    }

    .product .content ul li p{
      padding: 0;
      font-size: 12px;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #222222;
      line-height: 40px;
      overflow: hidden;
      /* text-overflow:ellipsis; */
      white-space: nowrap;
    }

    .product .minde .top{
      margin-top: 20px;
    }

    .product .minde .top > img:nth-child(1){
      display: none;
    }

    .product .minde .top > img:nth-child(2){
      display: block;
    }

    .product .minde .top ul{
      width: 100%;
      display: flex;
      justify-content: space-evenly;
    }

    .product .minde .top ul li{
      width: 20%;
    }

    .product .minde .top ul li img{
      margin-bottom: 5px;
    }

    .product .minde .top ul li p{
      font-size: 16px;
    }

    .product .minde .bottom{
      display: none;
    }

    .product .minde .bottom-sj{
      display: block;
    }

    .product .minde .bottom-sj .title-sj{
      margin-top: 40px;
      width: 100%;
    }

    .product .minde .bottom-sj .title-sj p:nth-child(1){
      text-align: center;
      font-size: 25px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #323F4F;
    }

    .product .minde .bottom-sj .title-sj p:nth-child(2){
      font-size: 0;
      width: 55px;
      height: 2px;
      background-color: #FFC200;
      text-align: center;
      margin: 15px auto 0;
    }

    .product .minde .top-wrap{
      width: 100%;
      box-sizing: border-box;
      position: relative;
    }

    .product .minde .top-wrap .top-sj{
      position: absolute;
      top: 0;
      left: 4%;
      z-index: 66;
      box-sizing: border-box;
      width: 92%;
      background-color: #fff;
      padding: 30px 20px 30px;
    }

    .product .minde .top-wrap .top-sj .word{
      display: flex;
      margin-top: 10px;
    }

    .product .minde .top-wrap .top-sj .word p:nth-child(1){
      font-size: 16px;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #222222;
      white-space: nowrap;
      padding-right: 15px;
      line-height: 25px;
    }

    .product .minde .top-wrap .top-sj .word p:nth-child(2){
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      text-align: justify;
      color: #666666;
      line-height: 25px;
    }

    .product .minde .top-wrap .top-sj .word:nth-child(1) p:nth-child(2){
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }

    .product .minde .top-wrap .top-sj .word:nth-child(2) p:nth-child(2){
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }

    .product .minde .top-wrap .top-sj .word:nth-child(3) p:nth-child(2){
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }

    .product .minde .top-wrap img{
      padding-top: 90px;
      width: 100%;
      display: block;
    }

    /* 企业实力 */

    .strength{
      padding-top: 40px;
    }

    .strength .title{
      width: 100%;
    }

    .strength .title p:nth-child(1){
      text-align: center;
      font-size: 25px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #323F4F;
    }

    .strength .title p:nth-child(2){
      font-size: 0;
      width: 55px;
      height: 2px;
      background-color: #FFC200;
      text-align: center;
      margin: 15px auto 0;
    }

    .strength .content-out{
      margin-top: 30px;
    }

    .strength .content-out > img:nth-child(1){
      display: none;
    }

    .strength .content-out > img:nth-child(2){
      display: block;
    }

    .strength .content{
      display: none;
    }

    /* 行业资讯 */

    .news{
      padding: 40px 0 0;
    }

    .news .title{
      width: 100%;
    }

    .news .title p:nth-child(1){
      text-align: center;
      font-size: 25px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #323F4F;
    }

    .news .title p:nth-child(2){
      font-size: 0;
      width: 55px;
      height: 2px;
      background-color: #FFC200;
      text-align: center;
      margin: 15px auto 0;
    }

    .news .top{
      display: none;
    }

    .news .bottom{
      display: none;
    }

    .news-sj{
      display: block;
      padding: 30px 20px 0;
      box-sizing: border-box;
    }

    .news-sj .top-sj{
      position: relative;
    }

    .news-sj .top-sj img{
      width: 100%;
      display: block;
    }

    .news-sj .top-sj .word{
      box-sizing: border-box;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      background-color:rgba(0, 0, 0, 0.5);
      z-index: 66;
      padding: 16px 10px;
    }

    .news-sj .top-sj .word p:nth-child(1){
      font-size: 14px;
      color: #fff;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 30px;
    }

    .news-sj .top-sj .word p:nth-child(2){
      font-size: 16px;
      color: #fff;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 30px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }

    .news-sj .bottom-sj ul{
      list-style: none;
    }

    .news-sj .bottom-sj ul li{
      box-sizing: border-box;
      padding: 20px 0;
      border-bottom: 1px solid #ddd;
    }

    .news-sj .bottom-sj ul li:last-child{
      border-bottom: 0;
    }

    .news-sj .bottom-sj ul li .left{
      float: left;
      width: 75px;
      height: 75px;
      /* background-color: #FFC200; */
      box-sizing: border-box;
      margin-right: 15px;
    }

    .news-sj .bottom-sj ul li .left p:nth-child(1){
      padding: 12px 5px 5px;
      /* color: #fff; */
      color: #999999;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
    }

    .news-sj .bottom-sj ul li .left p:nth-child(2){
      padding: 0 5px;
      /* color: #fff; */
      color: #999999;
      font-size: 22px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
    }

    .news-sj .bottom-sj ul li .right{
      height: 75px;
      box-sizing: border-box;
      padding-left: 20px;
    }

    .news-sj .bottom-sj ul li .right p:nth-child(1){
      font-size: 18px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      /* color: #FFC200; */
      color: #222222;
      line-height: 30px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }

    .news-sj .bottom-sj ul li .right p:nth-child(2){
      font-size: 13px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }

    .news-sj .bottom-sj .button{
      margin-top: 10px;
      width: 100%;
    }

    .news-sj .bottom-sj .button a{
      text-decoration: none;
    }

    .news-sj .bottom-sj .button p{
      text-align: center;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
    }

    .return-top{
      display: none;
    }
  }

  @media (max-width: 340px){ 
    .strength .title p:nth-child(1){
      font-size: 23px;
    }
  }


</style>


// WEBPACK FOOTER //
// src/views/Home.vue